export const metaOptions = [
  { label: 'General metadata', value: 'general', type: 'meta' },
  {
    label: 'Music Director(serial numbering)',
    value: 'serial',
    type: 'meta',
  },
  { label: 'Harvest ingestion', value: 'harvest', type: 'meta' },
];

export const tracksOptions = [
  { label: 'mp3 320 kb/s', value: 'file', type: 'music' },
  { label: 'mp3 320-48 kb/s', value: 'file_48khz', type: 'music' },
  { label: 'Wave 16 bit 44,1 kHz', value: 'file_wav', type: 'music' },
  {
    label: 'Wave 16 bit 48 kHzkHz',
    value: 'file_wav_48khz',
    type: 'music',
  },
  {
    label: 'Wave 24bit 44.1 kHz',
    value: 'file_wav_44khz',
    type: 'music',
  },
  {
    label: 'Wave 16 bit 48 kHz - Serial',
    value: 'serial',
    type: 'music',
  },
];

export const stemsOptions = [{ label: 'Stems', value: 'stems', type: 'music' }];

export const albumBatchOptions = [
  {
    label: 'Music files',
    options: tracksOptions,
  },
  {
    label: 'Meta data',
    options: metaOptions,
  },
];

export const stemBatchOptions = [
  {
    label: 'Music files',
    options: stemsOptions,
  },
];

export const albumOptions = fileOptions => [
  {
    label: 'Music files:',
    options: fileOptions,
  },
  {
    label: 'Meta data',
    options: [
      { label: "Album's cover", value: 'cover', type: 'cover' },
      ...metaOptions,
    ],
  },
];

export const stemAlbumOptions = [
  {
    label: 'Music files:',
    options: stemsOptions,
  },
];

export const getAlbumBatchOptions = album => {
  const albumTracksOptions = [];

  tracksOptions.forEach(option => {
    if (album[`has_${option.value}`]) {
      albumTracksOptions.push(option);
    }
  });

  if (
    albumTracksOptions.map(o => o.value).some(el => el === 'file_wav_48khz')
  ) {
    albumTracksOptions.push({
      label: 'Wave 16 bit 48 kHz - Serial',
      value: 'serial',
      type: 'music',
    });
  }
  return [
    {
      label: 'Music files',
      options: albumTracksOptions,
    },
    {
      label: 'Meta data',
      options: metaOptions,
    },
  ];
};
